import { Box } from '@mui/material';

import { SALE_ORDER_STATUS } from '@bandido/shared/constants';
import { HotelFareCard } from '@frontend/features/hotel/components/Fares';

import { useCart } from '../CartContext';
import { SaleOrderItemResponseDto } from '@bandido/shared/dtos';

interface Props {
  service: SaleOrderItemResponseDto
}

export const CartItem = ({ service }: Props) => {

  const { state, removeItem } = useCart();
  const [quotation] = service?.quotations || [];
  if (service.type === 'hotel' && service.metadata) {
    
    return (
      <Box
        display="flex"
        gap={1}
        justifyContent="space-between"
        position="relative"
      >
        <HotelFareCard
          fare={{
            id: service.metadata.fareId,
            propertyName: service.metadata.propertyName,
            optionRefId: service.metadata.optionRefId,
            accessCode: service.metadata.accessCode,
            checkinDate: service.metadata.checkinDate,
            checkoutDate: service.metadata.checkoutDate,
            context: service.metadata.context,
            hotelCode: service.metadata.hotelCode,
            boardCode: service.metadata.boardCode,
            boardDescription: service.metadata.boardDescription,
            paymentType: service.metadata.paymentType,
            refundable: service.metadata.refundable,
            currency: service.metadata.currency,
            finalPrice: service.metadata.finalPrice,
            markupId: service.markupRuleId,
            markupValue: service.markupValue,
            markupIsFixed: service.markupIsFixed,
            cancelPenalties: service.metadata.cancelPenalties || [],
            rooms: service.metadata.rooms || [],
            occupancies: service.metadata.occupancies || [],
            cancelPolicy: quotation?.cancelPolicy || service.metadata?.cancelPolicy || null,
            surcharges: quotation?.surcharges || [],
            priceMarkups: quotation?.price.markups || [],
            remarks: quotation?.remarks || null,
            gross: quotation?.price.gross,
            searchHistoryId: 0,
            exchangeRate: 0,
            net: 0,
            createdAt: new Date(),
            updatedAt: new Date(),
            searchId: ' - ',
            status: ' - ',
            exchangeCurrency: ' - ',
            binding: false,
            supplements: [],
            rateRules:  service.metadata?.rateRules || [],
            minimumSellingPrice: null,
          }}
          onRemoveFromCart={
            state?.status !== SALE_ORDER_STATUS.Sold ? () => removeItem(service.id!) : undefined
          }
        />
      </Box >
    );
  }

  return null;
};
